<template>
  <div class="blockC matching-box clearfix" style="margin-top: 20px">
    <div class="blockC-detail">
      <div class="blockC-tip"></div>
      <span class="blockC-title">电子合同信息：</span>
    </div>
    <vxe-form
        style="margin-top: 10px;"
        ref="ele"
        class="my-form"
        title-align="right"
        :data="formData"
        :rules="formRules"
        title-width="120"
        prevent-submit>
      <vxe-form-item title="定金" field="prepayment" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.prepayment" placeholder="选填" clearable
                     @input="$refs.ele.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="滞期费" field="demurrageAmount" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.demurrageAmount" placeholder="选填" clearable
                     @input="$refs.ele.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="装卸天数" field="unloadDay" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.unloadDay" placeholder="选填" clearable
                     @input="$refs.ele.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="付款方式" field="payWay" span="8">
        <template v-slot="scope">
          <vxe-input v-model="formData.payWay" placeholder="选填" clearable
                     @input="$refs.ele.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
      <vxe-form-item title="计量及交接方式" field="deliveryWay" span="16">
        <template v-slot="scope">
          <vxe-input v-model="formData.deliveryWay" placeholder="选填" clearable
                     @input="$refs.ele.updateStatus(scope)"></vxe-input>
        </template>
      </vxe-form-item>
    </vxe-form>
  </div>
</template>

<script>

  export default {
    props: ['isSubmit', 'isCancel', 'isSave', 'detailData'],
    data() {
      return {
        formData: {
          prepayment: null,
          demurrageAmount: null,
          unloadDay: null,
          payWay: null,
          deliveryWay: null,
        },
        formRules: {
          prepayment: [{max: 10, message: "定金最多10字"}],
          unloadDay: [{max: 10, message: "装卸天数最多10字"}],
          payWay: [{max: 10, message: "付款方式最多10字"}],
          demurrageAmount: [{max: 16, message: "滞期费最多16字"}],
          deliveryWay: [{max: 16, message: "计量及交接方式最多16字"}],
        },
      };
    },
    watch: {
      isSubmit(val) {
        if (val) {
          this.check();
        }
      },
      isCancel(val) {
        if (val) {
          this.reset();
        }
      },
      isSave(val) {
        if (val) {
          this.setParams();
        }
      },
      detailData(val) {
        if (val) {
          this.formData = {
            prepayment: this.detailData.prepayment,
            demurrageAmount: this.detailData.demurrageAmount,
            unloadDay: this.detailData.unloadDay,
            payWay: this.detailData.payWay,
            deliveryWay: this.detailData.deliveryWay,
          }
        }
      }
    },
    methods: {
      async check() {
        const errMap = await this.$refs.ele.validate().catch(errMap => errMap);
        if (errMap) {
          this.$emit("setParams", false);
          return
        }
        this.setParams();
      },
      setParams() {
        // 过滤参数
        let obj = {
          prepayment: this.formData.prepayment,
          demurrageAmount: this.formData.demurrageAmount,
          unloadDay: this.formData.unloadDay,
          payWay: this.formData.payWay,
          deliveryWay: this.formData.deliveryWay,
        };
        this.$emit("setParams", obj);
      },
      clearValidate() {
        this.$refs.ele.clearValidate();
      },
      reset() {
        this.formData = {
          prepayment: null,
          demurrageAmount: null,
          unloadDay: null,
          payWay: null,
          deliveryWay: null,
        };
        this.clearValidate();
      }
    }
  };
</script>

<style scoped>

</style>